'use client';
/**
 * components/auth/BoutonCompte.tsx — avatar + déconnexion.
 *
 * LE bouton de compte de l'application, partout. Il vient de
 * `components/prestataire/AccountButton.tsx`, écrit le 27/07 pour remplacer
 * <UserButton> de Clerk sur la carte prestataire — deux raisons qui valaient
 * pour tous les écrans, pas seulement celui-là : le portail de Clerk montait un
 * arbre à lui au-dessus de la page (écran blanc « Rendered more hooks »), et il
 * n'offrait aucune sortie quand la page plantait, laissant l'utilisateur
 * connecté sans pouvoir se déconnecter.
 */
import { useState } from 'react';
import { useCompte, seDeconnecter } from '@/lib/auth/client';

export default function BoutonCompte({ redirectUrl = '/bienvenue' }: { redirectUrl?: string }) {
  const { user } = useCompte();
  const [open, setOpen] = useState(false);

  const initial = (user?.firstName ?? user?.email ?? '?')
    .trim()
    .charAt(0)
    .toUpperCase();

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Mon compte"
        aria-expanded={open}
        className="w-9 h-9 rounded-full bg-[#383838] ring-2 ring-emerald-500/50 shadow-[0_4px_14px_rgba(0,0,0,.5)] flex items-center justify-center text-sm font-black text-emerald-300 active:scale-95 transition"
      >
        {initial}
      </button>

      {open && (
        <>
          {/* Clic extérieur : referme sans voile visible */}
          <button type="button" aria-hidden tabIndex={-1} onClick={() => setOpen(false)}
            className="fixed inset-0 z-[1400] cursor-default" />
          <div className="absolute right-0 mt-2 z-[1401] w-52 rounded-2xl bg-[#383838] border border-white/12 shadow-[0_12px_40px_rgba(0,0,0,.55)] overflow-hidden">
            <div className="px-3.5 py-2.5 border-b border-white/8">
              <span className="block text-xs text-white/45">Connecté en tant que</span>
              <span className="block text-[12.5px] font-bold truncate">
                {user?.email ?? '—'}
              </span>
            </div>
            <button
              type="button"
              onClick={() => void seDeconnecter(redirectUrl)}
              className="w-full px-3.5 py-3 text-left text-sm font-bold text-rose-300 active:bg-white/5"
            >
              Se déconnecter
            </button>
          </div>
        </>
      )}
    </div>
  );
}
